import { orderBy } from "lodash"
import SelectorBox2 from "@/components/SelectorBox2";

const DataElementsList = ({ items, selected, onChange }) => {

	const sortedItems = orderBy(items, [item => item?.name?.toLowerCase()], ['asc'])

	const list = sortedItems.map((dataElement) => {
		if (!dataElement?.id) {
			return <></>
		}

		const active = selected?.id === dataElement.id

		return (
			<div className="data-element-selectors__col" key={dataElement.id} onClick={() => onChange(dataElement)} data-testid={active ? 'active-selector' : 'non-active-selector'}>
				<SelectorBox2 label={dataElement?.name} active={active} />
			</div>
		)
	})
	return (list.length > 0 ? list : <div className="data-element-selectors__col">There are no data elements to provide</div>)
}

export default DataElementsList
